import { render } from "./ListIzinAllView.vue?vue&type=template&id=a3041cc6"
import script from "./ListIzinAllView.vue?vue&type=script&lang=js"
export * from "./ListIzinAllView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__